import { Component, Input, EventEmitter, Output} from '@angular/core';

/**
   * Logger Factory
   * @namespace icon: icon to show
   * @namespace title: title to show
*/

@Component({
  selector: 'ute-menu-item',
  templateUrl: 'ute-menu-item.component.html'
})
export class UteMenuItem  {
  @Input() icon: string;
  @Input() title: string;
  @Input() action: string;
  @Output() clickItem = new EventEmitter;

  constructor() {
  }

  ngOnInit() {
    
  }

  onClickAction(action){
    this.clickItem.emit(action);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-menu-item/ute-menu-item.component.ts